
export const REQUEST_ADDNEWUSERGENPOOL= 'REQUEST_ADDNEWUSERGENPOOL';
export const ADDNEWUSERGENPOOL_RECEIVED = 'ADDNEWUSERGENPOOL_RECEIVED';